import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({
  created: { type: 'date' },
})
export class Version extends Mappable {
  number!: number | null
  created!: Date | null
  author!: string | null

  static create<Data>(attrs: Data) {
    return new Version().map(attrs)
  }
}
